// 难度选择弹窗
import CustomPopup from "../../../../components/CustomPopup";
import React, {useContext, useEffect} from "react";
import {PageEnum} from "../../../../types/IPage.ts";
import './BattleLinkDialog.css'
import {ThemeContext} from "../../../../providers/themeContext/theme-context.tsx";
import {ToastContext} from "../../../../components/CustomToast/ToastProvider.tsx";
import {ShareUtil} from "../../../../common/utils/share-util/shareUtil.ts";
import {UrlHandler} from "../../../../common/utils/urlHandler/UrlHandler.ts";
import {CommonKey} from "../../../../common/common-key/CommonKey.ts";
import {GAEvents} from "../../../../common/utils/GA4/GAEvents.ts";
import copy from 'copy-to-clipboard';

interface BattleLinkDialogProps {
    isOpen: boolean,
    onClose: () => void,
    roomId?: string,
    switchPage: (page: PageEnum) => void,
    isShowInWaitingPage?: boolean, // 是否在等待页面显示
}


const BattleLinkDialog: React.FC<BattleLinkDialogProps> = ({
                                                               isOpen,
                                                               onClose,
                                                               roomId,
                                                               switchPage,
                                                               isShowInWaitingPage
                                                           }) => {
    // 主题管理器
    const {imgUrls} = useContext(ThemeContext);
    const {addToast} = useContext(ToastContext);

    useEffect(() => {
        if (isOpen) {
            if (!isShowInWaitingPage) {
                // GA埋点
                GAEvents.createMatchShowInWaitingPage()
            } else {
                // GA埋点
                GAEvents.createMatchLinkShow()
            }
        }
    }, [isOpen]);

    // 跳转到倒计时页面
    const startBattle = () => {
        // GA埋点
        GAEvents.createMatchLinkStart()
        switchPage(PageEnum.VS_PLAYER_WAITING_PAGE)
    }

    // 分享链接
    const shareLink = async () => {
        if (!roomId) return;
        const mewUrl = UrlHandler.setCurrentUrlParamAndReturnUrl(CommonKey.ROOM_ID, roomId)


        if (isShowInWaitingPage) {
            // GA埋点
            GAEvents.createMatchInviteClickShare()
        } else {
            // GA埋点
            GAEvents.createMatchLinkShare()
        }

        await ShareUtil.share(new URL(mewUrl), (e) => {
            addToast({type: "warning", message: `Share error：${e};roomId:${roomId}`})
        })
    }

    // 复制链接
    const copyLinkToClipboard = () => {
        if (!roomId) return;
        const newUrl = UrlHandler.setCurrentUrlParamAndReturnUrl(CommonKey.ROOM_ID, roomId)
        copy(newUrl)
        addToast({
            type: 'success',
            message: 'Copied!'
        })
    }

    return (
        <CustomPopup isOpen={isOpen} onClose={onClose}>
            <div className="battle-link-modal-container">
                <img className="common-dialog-embellish-bg-left-top" src={imgUrls.leftTopBgDialogUrl} alt="pic"/>
                <img className="common-dialog-embellish-bg-right-bottom" src={imgUrls.rightBottomBgDialogUrl}
                     alt="pic"/>
                {/*标题*/}
                <div
                    className="font-size-16 my-roboto-bold text-center margin-top-11 height-26 display-flex-row display-flex-justify-content-center display-flex-align-items-center">
                    Battle Link
                    <img onClick={onClose} src={imgUrls.closerBtnGreyUrl} className="exit-close-btn"
                         alt="pic"/>
                </div>
                {/*链接地址框*/}
                <div
                    className={`${isShowInWaitingPage ? 'margin-top-27' : 'margin-top-13'} my-roboto-regular width-260 height-43 bg-color-grey-input border-color-grey-input border-radius-5 margin-left-right-auto display-flex-row display-flex-justify-content-center display-flex-align-items-center`}>
                    <div className="margin-left-14 font-size-14 color-grey width-40">room:</div>
                    <div className="color-blue margin-left-14 margin-right-14 width-172 ellipsis">{roomId}</div>
                </div>
                {/*图标按钮*/}
                <div
                    className={`${isShowInWaitingPage ? 'margin-top-20 width-120' : 'margin-top-8 width-106'} display-flex-row  height-33 display-flex-space-between margin-left-right-auto`}>
                    {/*分享按钮*/}
                    <div onClick={shareLink}
                         className={`${isShowInWaitingPage? 'width-40 height-40' : 'height-33 width-33'} border-radius-round battle-link-modal-share-bg  display-flex-row display-flex-align-items-center display-flex-justify-content-center`}>
                        <img className={`${isShowInWaitingPage? 'width-26 height-26' : 'height-21 width-21'}`} src={imgUrls.shareWhiteIcon} alt="pic"/>
                    </div>
                    {/*复制按钮*/}
                    <div onClick={copyLinkToClipboard}
                         className={`${isShowInWaitingPage? 'width-40 height-40' : 'height-33 width-33'} border-radius-round battle-link-modal-copy-bg display-flex-row display-flex-align-items-center display-flex-justify-content-center`}>
                        <img className={`${isShowInWaitingPage? 'width-26 height-26' : 'height-21 width-21'}`}  src={imgUrls.copyWhiteIcon} alt="pic"/>
                    </div>
                </div>
                <div
                    className={`${isShowInWaitingPage ? 'margin-top-22' : 'margin-top-8'} width-260 margin-left-right-auto display-flex-column text-center`}>
                    Share the link with your friends to compete with them!
                </div>
                {/*开始游戏按钮*/}
                {isShowInWaitingPage === true ? undefined :
                    <div onClick={startBattle}
                         className="margin-top-13 height-43 width-260 battle-link-modal-start-match-bg border-radius-5 margin-left-right-auto color-white font-size-16 my-roboto-medium display-flex-row display-flex-align-items-center display-flex-justify-content-center">
                        Start Match
                    </div>}
            </div>
        </CustomPopup>
    )
}

export default BattleLinkDialog;